import type { ConfigType } from '@plone/registry';
import {
  BacklogView,
  BlankView,
  BlanksView,
  CategoriesView,
  CategoryView,
  ChannelView,
  ChannelsView,
  ContactView,
  ContactsView,
  DashboardView,
  GiftCardView,
  GiftCardsView,
  InventoryView,
  OrderView,
  OrdersView,
  SetView,
  SiteView,
  SizeView,
  ToolView,
  ToolsView,
} from '../components';
import OrderToolsWidget from '../components/Widgets/OrderToolsWidget/OrderToolsWidget';
import CodeWidget from '../components/Widgets/CodeWidget/CodeWidget';
import CurrencyWidget from '../components/Widgets/CurrencyWidget/CurrencyWidget';
import DateTimeNowWidget from '../components/Widgets/DateTimeNowWidget/DateTimeNowWidget';
import ContactWidget from '../components/Widgets/ContactWidget/ContactWidget';
import ChannelWidget from '../components/Widgets/ChannelWidget/ChannelWidget';
import EmailWidget from '../components/Widgets/EmailWidget/EmailWidget';
import CountryWidget from '../components/Widgets/CountryWidget/CountryWidget';
import PhoneWidget from '../components/Widgets/PhoneWidget/PhoneWidget';
import PostalcodeWidget from '../components/Widgets/PostalcodeWidget/PostalcodeWidget';
import Payment from '../components/Payment/Payment';
import PrivacyPolicy from '../components/PrivacyPolicy/PrivacyPolicy';
import TermsOfService from '../components/TermsOfService/TermsOfService';
import StateWidget from '../components/Widgets/StateWidget/StateWidget';
import OrderShippingFeeWidget from '../components/Widgets/OrderShippingFeeWidget/OrderShippingFeeWidget';
import currency from '../reducers/currency/currency';

export default function install(config: ConfigType) {
  // Language settings
  config.settings.isMultilingual = false;
  config.settings.supportedLanguages = ['en'];
  config.settings.defaultLanguage = 'en';

  config.addonReducers = {
    ...config.addonReducers,
    currency,
  };

  config.views.contentTypesViews['Backlog'] = BacklogView;
  config.views.contentTypesViews['Blank'] = BlankView;
  config.views.contentTypesViews['Blanks'] = BlanksView;
  config.views.contentTypesViews['Categories'] = CategoriesView;
  config.views.contentTypesViews['Category'] = CategoryView;
  config.views.contentTypesViews['Channel'] = ChannelView;
  config.views.contentTypesViews['Channels'] = ChannelsView;
  config.views.contentTypesViews['Contact'] = ContactView;
  config.views.contentTypesViews['Contacts'] = ContactsView;
  config.views.contentTypesViews['Dashboard'] = DashboardView;
  config.views.contentTypesViews['Giftcard'] = GiftCardView;
  config.views.contentTypesViews['Giftcards'] = GiftCardsView;
  config.views.contentTypesViews['Inventory'] = InventoryView;
  config.views.contentTypesViews['Order'] = OrderView;
  config.views.contentTypesViews['Orders'] = OrdersView;
  config.views.contentTypesViews['Set'] = SetView;
  config.views.contentTypesViews['Site'] = SiteView;
  config.views.contentTypesViews['Size'] = SizeView;
  config.views.contentTypesViews['Tool'] = ToolView;
  config.views.contentTypesViews['Tools'] = ToolsView;

  config.widgets.widget['order_tools'] = OrderToolsWidget;
  config.widgets.widget['code'] = CodeWidget;
  config.widgets.widget['currency'] = CurrencyWidget;
  config.widgets.widget['datetimenow'] = DateTimeNowWidget;
  config.widgets.widget['contact'] = ContactWidget;
  config.widgets.widget['channel'] = ChannelWidget;
  config.widgets.widget['email'] = EmailWidget;
  config.widgets.widget['country'] = CountryWidget;
  config.widgets.widget['phone'] = PhoneWidget;
  config.widgets.widget['postalcode'] = PostalcodeWidget;
  config.widgets.widget['state'] = StateWidget;
  config.widgets.widget['order_shipping_fee'] = OrderShippingFeeWidget;

  config.addonRoutes = [
    ...(config.addonRoutes || []),
    { path: '/payment', component: Payment },
    { path: '/privacy-policy', component: PrivacyPolicy },
    { path: '/terms-of-service', component: TermsOfService },
  ];

  return config;
}
